import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ExitIntentModal from "./components/ExitIntentModal";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import GettingStarted from "./pages/GettingStarted";
import Recipes from "./pages/Recipes";
import Dictionary from "./pages/Dictionary";
import Troubleshooting from "./pages/Troubleshooting";
import CareGuides from "./pages/CareGuides";
import FAQ from "./pages/FAQ";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/getting-started" element={<GettingStarted />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/dictionary" element={<Dictionary />} />
          <Route path="/troubleshooting" element={<Troubleshooting />} />
          <Route path="/care" element={<CareGuides />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <ExitIntentModal />
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
